import Login from "./components/login/Login";
import WelcomePage from "./components/welcomePage/WelcomePage";
import PersonalPage from "./components/personalPage/PersonalPage";
import useAuthAuthenticate from "./hooks/useAuthAuthenticate";
import useAuthIdleTimer from "./hooks/useAuthIdleTimer";
import usePassword from "./hooks/usePassword";
import usePersonalPage from "./hooks/usePersonalPage";
import userReducer from "./store/userSlice";
import { User, UserSettings, UserProfileState } from "./interfaces/interfaces";
import {
  USER_SETTINGS_LOCALSTORAGE_NAME,
  USER_LOCALSTORAGE_NAME,
  initialsRegex,
  validLanguages,
} from "./constants";
import { getInitialsFromName } from "./utils/utils";

export {
  useAuthAuthenticate,
  useAuthIdleTimer,
  usePassword,
  usePersonalPage,
  userReducer,
  getInitialsFromName,
  Login,
  WelcomePage,
};
export {
  USER_SETTINGS_LOCALSTORAGE_NAME,
  USER_LOCALSTORAGE_NAME,
  initialsRegex,
  validLanguages,
};
export type { User, UserSettings, UserProfileState };

export default PersonalPage;
